import {
    AUTOMATIC_TAX_CALCULATION,
    IOrderSale,
    REQUIRE_TAX,
    TAX,
} from '../../order-sale-form';
import { RhNumberField } from '../../../../../../../dum';
import { useCalculateProductsTotal } from '../../helpers/use-calculate-products-total';
import { useWatch } from 'react-hook-form';
import { useOrderSaleOrderSaleReceiptTypeInputQuery } from '../../../../../../../../services';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../helpers';

export function TaxInput() {
    const { calculateProductsTotal } = useCalculateProductsTotal();
    const { data } = useOrderSaleOrderSaleReceiptTypeInputQuery();
    const automaticTaxCalculation = useWatch({
        name: AUTOMATIC_TAX_CALCULATION,
    }) as IOrderSale['automatic_tax_calculation'];
    const requireTax = useWatch({
        name: REQUIRE_TAX,
    }) as IOrderSale['require_tax'];
    const tax = useWatch({ name: TAX }) as IOrderSale['tax'];
    const receiptTypeId = useWatch({
        name: 'receipt_type_id',
    }) as IOrderSale['receipt_type_id'];
    const selectedReceiptType = (data?.getReceiptTypes ?? []).find(
        (receiptType) => receiptType.id === receiptTypeId,
    );
    const appliesTax = (selectedReceiptType?.tax_multiplier ?? 1) > 1;

    return (
        <RhNumberField
            name={TAX}
            label={shortLabel(FIELD_LABELS.tax)}
            onChange={() => {
                calculateProductsTotal();
            }}
            disabled={
                automaticTaxCalculation ||
                !appliesTax ||
                (!requireTax && Number(tax) === 0)
            }
        />
    );
}
